import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/material'
import { Label } from '../../../../components/styled/global.style'
import { FormError, InputBaseStyle, TextFieldStyle } from '../../Trade.style'

const RemainingOptionsTrade = ({
  form,
  handelDateChange,
  handelFormChange,
  disabled = false,
  errors
}) => {
  return (
    <>
      <Box width={'100%'}>
        <Label>Spot Ref *</Label>
        <InputBaseStyle
          name="spot_ref"
          placeholder="0.00"
          value={form.spot_ref}
          disabled={disabled}
          onChange={handelFormChange}
        />
      </Box>
      <Box width={'100%'}>
        <Label>Window Start *</Label>
        <TextFieldStyle
          type="date"
          variant="outlined"
          value={form.window_start}
          myerror={String(!!errors.window_start)}
          disabled={disabled}
          onChange={event => handelDateChange('window_start', event.target.value)}
        />
        {errors.window_start && <FormError>{errors.window_start}</FormError>}
      </Box>
      <Box width={'100%'}>
        <Label>Window End *</Label>
        <TextFieldStyle
          type="date"
          variant="outlined"
          value={form.window_end}
          disabled={disabled}
          onChange={event => handelDateChange('window_end', event.target.value)}
        />
      </Box>
      <Box width={'100%'}>
        <Label>Barrier *</Label>
        <InputBaseStyle
          value={form.barrier}
          name="barrier"
          disabled={disabled}
          onChange={handelFormChange}
          placeholder="0.00"
        />
      </Box>
    </>
  )
}

export default RemainingOptionsTrade

RemainingOptionsTrade.propTypes = {
  disabled: PropTypes.bool,
  handelFormChange: PropTypes.func,
  handelDateChange: PropTypes.func,
  form: PropTypes.object,
  errors: PropTypes.object
}
